import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "button", "spinner", "hint"]

  // 点击 sample tag 填入 textarea
  fill(event) {
    this.textareaTarget.value = event.currentTarget.dataset.text
    this.textareaTarget.focus()
    this.clearHint()
  }

  // 用户开始输入时清掉错误提示
  clearHint() {
    if (this.hasHintTarget) this.hintTarget.classList.add("hidden")
  }

  // 表单提交前校验 + 切换到 spinner 状态
  submit(event) {
    if (this.textareaTarget.value.trim() === "") {
      event.preventDefault()
      if (this.hasHintTarget) this.hintTarget.classList.remove("hidden")
      this.textareaTarget.focus()
      return
    }
    this.clearHint()
    this.buttonTarget.style.display = "none"
    this.spinnerTarget.style.display = "flex"
  }
}
